export const SHIPMENT_DETAILS_MODAL_OPEN = 'SHIPMENT_DETAILS_MODAL_OPEN';
export const SHIPMENT_DETAILS_MODAL_CLOSED = 'SHIPMENT_DETAILS_MODAL_CLOSED';
export const GET_SHIPMENT_DETAILS_REQUEST = 'GET_SHIPMENT_DETAILS_REQUEST';
export const GET_SHIPMENT_DETAILS_SUCCESS = 'GET_SHIPMENT_DETAILS_SUCCESS';
export const GET_SHIPMENT_DETAILS_FAILURE = 'GET_SHIPMENT_DETAILS_FAILURE';
export const PRINT_PREVIEW = 'PRINT_PREVIEW';
export const SHIPMENT_NOTIFY_MARKETPLACE_REQUEST = 'SHIPMENT_NOTIFY_MARKETPLACE_REQUEST';
export const SHIPMENT_NOTIFY_MARKETPLACE_FAILURE = 'SHIPMENT_NOTIFY_MARKETPLACE_FAILURE';
export const SHIPMENT_NOTIFY_MARKETPLACE_SUCCESS = 'SHIPMENT_NOTIFY_MARKETPLACE_SUCCESS';
export const CLEAR_SHIPMENT_FROM_CUSTOMER_DETAILS_TRACKER = 'CLEAR_SHIPMENT_FROM_CUSTOMER_DETAILS_TRACKER';
export const UPDATE_SHIPMENT = 'UPDATE_SHIPMENT';
export const VALIDATE_ADDRESS_SHIPMENT_DETAILS_SHIPTO = 'VALIDATE_ADDRESS_SHIPMENT_DETAILS_SHIPTO';
export const VALIDATE_ADDRESS_SHIPMENT_DETAILS_SHIPTO_SUCCESS = 'VALIDATE_ADDRESS_SHIPMENT_DETAILS_SHIPTO_SUCCESS';
export const VALIDATE_ADDRESS_SHIPMENT_DETAILS_SHIPTO_FAILURE = 'VALIDATE_ADDRESS_SHIPMENT_DETAILS_SHIPTO_FAILURE';

// TODO: preventRouting is a temp workaround to prevent modal on batch list page to route to batch details
export const openShipmentDetailModal = (shipmentId, modalId, shipmentDetailModalId, preventRouting) => {
  return {
    type: SHIPMENT_DETAILS_MODAL_OPEN,
    shipmentId,
    modalId,
    shipmentDetailModalId,
    preventRouting,
  };
};

// TODO: instead, we should LBSM have an <AsModal /> shipment details in which LBSM can specify what action to dispatch
// as an prop.onClose to the <AsModal />
export const SHIPMENT_DETAILS_MODAL_OPEN_FROM_LABEL_BATCH_STATUS = 'SHIPMENT_DETAILS_MODAL_OPEN_FROM_LABEL_BATCH_STATUS';
export const openShipmentDetailsFromLabelBatchStatus = (fulfillmentPlanId, batchId) => ({
  type: SHIPMENT_DETAILS_MODAL_OPEN_FROM_LABEL_BATCH_STATUS,
  fulfillmentPlanId,
  batchId,
});

export const SHIPMENT_DETAILS_MODAL_FROM_LABEL_BATCH_STATUS_PROCESSING = 'SHIPMENT_DETAILS_MODAL_FROM_LABEL_BATCH_STATUS_PROCESSING';
export const openShipmentDetailsFromLabelBatchStatusProcessing = (fulfillmentPlanId, batchId) => ({
  type: SHIPMENT_DETAILS_MODAL_FROM_LABEL_BATCH_STATUS_PROCESSING,
  fulfillmentPlanId,
  batchId,
});

export const LOAD_SHIPMENT_DETAILS = 'LOAD_SHIPMENT_DETAILS';
export const loadShipmentDetails = (shipmentId) => {
  return {
    type: LOAD_SHIPMENT_DETAILS,
    shipmentId,
  };
};

export const closedShipmentDetailModal = (shipmentDetailModalId) => {
  return {
    type: SHIPMENT_DETAILS_MODAL_CLOSED,
    shipmentDetailModalId,
  };
};

export const requestShipmentDetails = (shipmentDetailModalId) => {
  return {
    type: GET_SHIPMENT_DETAILS_REQUEST,
    shipmentDetailModalId,
  };
};

export const getShipmentDetailsSuccess = (fulfillmentPlanId, shipmentDetailModalId) => {
  return {
    type: GET_SHIPMENT_DETAILS_SUCCESS,
    fulfillmentPlanId,
    shipmentDetailModalId,
  };
};

export const getShipmentDetailsFailure = (shipmentId, shipmentDetailModalId, error) => {
  return {
    type: GET_SHIPMENT_DETAILS_FAILURE,
    ...error,
    shipmentId,
    shipmentDetailModalId,
  };
};

export const printPreview = (shipmentDetailModalId) => {
  return {
    type: PRINT_PREVIEW,
    shipmentDetailModalId,
  };
};

export const SHIPMENT_DETAILS_GO_TO_ROUTE_FOR_FULFILLMENT = 'SHIPMENT_DETAILS_GO_TO_ROUTE_FOR_FULFILLMENT';
export const goToShipmentDetailsForFulfillmentId = (fulfillmentId) => ({
  type: SHIPMENT_DETAILS_GO_TO_ROUTE_FOR_FULFILLMENT,
  fulfillmentId,
});

export const SHIPMENT_DETAILS_GO_TO_ROUTE = 'SHIPMENT_DETAILS_GO_TO_ROUTE';
export const goToShipmentDetails = (fulfillmentPlanId) => ({
  type: SHIPMENT_DETAILS_GO_TO_ROUTE,
  fulfillmentPlanId,
});

export const launchShipmentDetail = goToShipmentDetails;

export const shipmentNotifyMarketplace = (shipmentDetailModalId) => {
  return {
    type: SHIPMENT_NOTIFY_MARKETPLACE_REQUEST,
    shipmentDetailModalId,
  };
};

export const shipmentNotifyMarketplaceSuccess = (fulfillmentsUpdated, shipmentDetailModalId) => {
  return {
    type: SHIPMENT_NOTIFY_MARKETPLACE_SUCCESS,
    fulfillmentsUpdated,
    shipmentDetailModalId,
  };
};

export const shipmentNotifyMarketplaceFailure = (error, fulfillmentIds) => {
  return {
    type: SHIPMENT_NOTIFY_MARKETPLACE_FAILURE,
    fulfillmentIds,
    error,
  };
};

export const updateShipment = (shipmentPayload, shipmentDetailModalId) => ({
  type: UPDATE_SHIPMENT,
  shipmentPayload,
  shipmentDetailModalId,
});

export const clearShipmentFromCustomerDetailsTracker = (status) => ({
  type: CLEAR_SHIPMENT_FROM_CUSTOMER_DETAILS_TRACKER,
  status,
});

export const validateShipmentDetailsShipToAddress = (address, shipmentId) => ({
  type: VALIDATE_ADDRESS_SHIPMENT_DETAILS_SHIPTO,
  address,
  shipmentId,
});

export const validateShipmentDetailsShipToAddressSuccess = (shipmentId) => ({
  type: VALIDATE_ADDRESS_SHIPMENT_DETAILS_SHIPTO_SUCCESS,
  shipmentId,
});

export const validateShipmentDetailsShipToAddressFailure = (error) => ({
  type: VALIDATE_ADDRESS_SHIPMENT_DETAILS_SHIPTO_FAILURE,
  error,
});
